import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { NAV_LINKS } from '../data/site';
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className="sticky top-0 z-40 w-full border-b border-ink-100 bg-white/95 backdrop-blur" data-id="element-174" data-mp="1iq5z17rj2983">
      <div className="mx-auto flex max-w-container items-center justify-between gap-6 px-6 py-4 lg:px-10" data-id="element-175" data-mp="v027hyrm5zxg">
        <Link to="/" className="flex shrink-0 items-center" aria-label="Keystone Technologies — home" data-id="element-176" data-mp="14wf00tbfa7qm">
          <span className="block h-9 w-[26px] shrink-0 bg-bronze-500" style={{
          clipPath: 'polygon(0 0, 100% 0, 80% 100%, 20% 100%)'
        }} aria-hidden="true" data-id="element-177" data-mp="zwagsvj4qywp" />
          <span className="ml-3 flex flex-col" aria-hidden="true" data-id="element-178" data-mp="2bbfpcg5xzro8">
            <span className="text-[1.25rem] font-medium leading-none tracking-tight text-ink-800" data-id="element-179" data-mp="29k2a4fp4jlug">
              KEYSTONE
            </span>
            <span className="mt-1 text-[0.5rem] font-medium leading-none tracking-[0.34em] text-ink-500" data-id="element-180" data-mp="2ehltfu0oiot9">
              TECHNOLOGIES
            </span>
            <span className="mt-1 block h-[2px] w-full bg-bronze-500" data-id="element-181" data-mp="2ogt3a787g1bm" />
          </span>
        </Link>

        <nav aria-label="Primary" className="hidden items-center gap-1 lg:flex" data-id="element-182" data-mp="1qtknmsuvxmhj">
          {NAV_LINKS.map(link => <NavLink key={link.to} to={link.to} end={link.to === '/'} className={({
          isActive
        }) => `relative px-4 py-2 text-sm font-medium transition-colors duration-150 ease-out ${isActive ? 'text-ink-900' : 'text-ink-500 hover:text-ink-900'}`} data-id="element-183" data-mp="1vrm210hd8xmo">
              {({
            isActive
          }) => <>
                  {link.label}
                  <span className={`absolute inset-x-4 -bottom-[17px] h-0.5 bg-bronze-500 transition-opacity duration-150 ease-out ${isActive ? 'opacity-100' : 'opacity-0'}`} aria-hidden="true" data-id="element-184" data-mp="14zx30ij9ocb8" />
                </>}
            </NavLink>)}
          <Link to="/contact" className="ml-4 inline-flex items-center whitespace-nowrap bg-ink-900 px-5 py-2.5 text-sm font-medium text-white transition-colors duration-150 ease-out hover:bg-bronze-600" data-id="element-185" data-mp="m23y5ap31sb7">
            Start a conversation
          </Link>
        </nav>

        <button type="button" onClick={() => setOpen(v => !v)} className="inline-flex items-center justify-center p-2 text-ink-700 lg:hidden" aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-186" data-mp="r0xfxfbek5h6">
          {open ? <XIcon className="h-5 w-5" data-id="element-187" data-mp="29z3fwmvqr1fp" /> : <MenuIcon className="h-5 w-5" data-id="element-188" data-mp="29ytmsqfege5s" />}
        </button>
      </div>

      {open && <nav id="mobile-nav" aria-label="Primary mobile" className="border-t border-ink-100 bg-white px-6 py-4 lg:hidden" data-id="element-189" data-mp="2f0src3mvlh4b">
          <ul className="flex flex-col" data-id="element-190" data-mp="250ih8rw50ptd">
            {NAV_LINKS.map(link => <li key={link.to} data-id="element-191" data-mp="2sqw9ojimwqoh">
                <NavLink to={link.to} end={link.to === '/'} className={({
            isActive
          }) => `block border-b border-ink-100 py-3 text-base font-medium ${isActive ? 'text-bronze-600' : 'text-ink-800'}`} data-id="element-192" data-mp="2srnuczap13zz">
                  {link.label}
                </NavLink>
              </li>)}
          </ul>
          <Link to="/contact" className="mt-4 inline-flex w-full items-center justify-center bg-ink-900 px-5 py-3 text-sm font-medium text-white" data-id="element-193" data-mp="3gg731fxnnisl">
            Start a conversation
          </Link>
        </nav>}
    </header>;
}